export const sortOrder = [
  '51787',
  '53072',
  '53055',
  '54061',
  '55898',
  '59424',
  '55358',
  '39386',
  '34554',
  '59619',
  '11289',
  '38081',
  '54430',
  '5935',
  '50827',
  '34184',
  '45245',
  '37237',
  '5236',
  '32725',
  '34829',
  '50942',
  '34139',
];

const crashGameIds = [
  '20786',
  '2014',
  '5935',
  '2010',
  '15543',
  '19',
  '15542',
  '10512',
  '6492',
  '5339',
  '5236',
  '11289',
  '27201',
  '32724',
  '34139',
  '34184',
  '32725',
  '34829',
  '34554',
  '35760',
  '35838',
  '36024',
  '35956',
  '32727',
  '37237',
  '37238',
  '38081',
  '37992',
  '39769',
  '39386',
  '42202',
  '37236',
  '41446',
  '45245',
  '42205',
  '47509',
  '48933',
  '50827',
  '47006',
  '50942',
  '53831',
  '54430',
  '59619',
];

const hiddenGameIds = ['33510'];

export const isHiddenGame = id => hiddenGameIds.includes(id);

export const getTab = id => (crashGameIds.includes(id) ? ['crash'] : []);
